<template>
  <button
    type="button"
    :disabled="disabled"
    :class="[
      'flex w-full items-start gap-2 rounded-lg border p-3 text-left transition-colors disabled:opacity-60',
      isCurrent ? 'border-royal-500 bg-white' : 'border-transparent bg-white hover:bg-grey-50',
    ]"
    @click="emit('select', company.id)"
  >
    <span
      class="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-grey-200 text-xs text-grey-700"
    >
      {{ initials }}
    </span>

    <div class="min-w-0 flex-1">
      <span class="block truncate text-sm leading-tight text-grey-950">{{ company.name }}</span>
      <span v-if="cnpj" class="block truncate text-xs leading-tight text-grey-600">{{ cnpj }}</span>
      <CompanyStatusBadge v-if="company.status" :status="company.status" class="mt-2" />
    </div>

    <span
      :class="[
        'mt-1 flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full border',
        isCurrent ? 'border-royal-500' : 'border-grey-600',
      ]"
    >
      <span v-if="isCurrent" class="h-2 w-2 rounded-full bg-royal-500" />
    </span>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { masks } from '@ecx/ui';

import CompanyStatusBadge from './CompanyStatusBadge.vue';
import type { Company } from '@/stores/company';

const props = defineProps<{
  company: Company;
  isCurrent: boolean;
  disabled: boolean;
}>();

const emit = defineEmits<{
  select: [companyId: string];
}>();

const initials = computed(() => props.company.name.trim().charAt(0).toUpperCase() || '?');

const cnpj = computed(() => {
  const digits = (props.company.cnpj ?? '').replace(/\D/g, '');
  return digits ? masks.cnpj(digits) : '';
});
</script>
